import { supportsArrayBuffer as t, nativeIsView as r, toString as i } from "./_setup.js";
import o from "./isDataView.js";
import a from "./constant.js";
import e from "./_isBufferLike.js";
var s = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/,
  m = t ? function (t) {
    return r ? r(t) && !o(t) : e(t) && s.test(i.call(t));
  } : a(!1);
export { m as default };